import { TranslatePipe } from '../../../filters/translate.pipe';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../../utils/session.service';
import RestService from '../../../services/core-rest.service';
import AngularHelperService from '../../../services/angular-helper.service';
import AngularFilterHelperService from '../../../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../../../services/angular-routing-helper.service';

@Component({
	standalone: true,
	selector: 'benu-prescription-purchase-landing-page',
	templateUrl: './benu-prescription-purchase-landing-page.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export default class BenuPrescriptionPurchaseLandingPageComponent implements OnInit {
	private session: Session = inject(Session);
	private restService: RestService = inject(RestService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		var accessToken: any = this.angularRoutingHelperService.getQueryParam('accessToken');
		if (!accessToken) {
			accessToken = this.angularRoutingHelperService.getCurrentRouteParam('accessToken');
		}
		this.restService.getBenuPublicAccessToken({ token: accessToken })
			.then((res) => {
				this.vm.tokenData = res;
				this.onResolve();
			}).catch(() => {
				this.vm.tokenData = { errorCode: "TOKEN_EXPIRED" };
				this.onResolve();
			});
	}
	
	onResolve() {
		this.vm.showOnlyThankYouSection = false;
		this.vm.consents = {};
		this.vm.consents.pharmacyDataSharingAccepted = false;
		this.vm.consents.pharmacyDataProcessingAccepted = false;
		this.vm.tokenIsExpired = false;
		
		this.vm.prescriptionNr = this.vm.tokenData.prescriptionNumber;
		this.vm.headerTextTranslated = this.angularFilterHelperService.translate('Benu.Prescription_Purchase_Landing_Page.Header')
			.replace('%s', this.vm.prescriptionNr);
		this.vm.isOpen = { service: true, consents: true };
		if (this.vm.tokenData.errorCode === "TOKEN_EXPIRED" && !this.session.isLoggedIn()) {
			this.vm.tokenIsExpired = true;
		}
		
		this.vm.submit = this.submit;
		this.vm.getRedirectLink = this.getRedirectLink;
		this.vm.goToLogin = this.session.goToLogin;
	}
	
	submit(mainForm: any) {
		this.vm.submitted = true;
		if (mainForm.invalid || this.vm.processing) {
			return;
		}
		this.vm.processing = true;
		
		var promises: Array<any> = [];
		promises.push(this.getRedirectLink());
		
		this.angularHelperService.getPromise().all(promises)
			.then((res) => {
				if (res[0] && res[0].redirectUrl) {
					window.open(res[0].redirectUrl, '_self');
				}
			}, (err) => {
				this.vm.processing = false;
			});
	}
	
	getRedirectLink() {
		var deferred: any = this.angularHelperService.getDeferredPromise();
		var accessToken: any = this.angularRoutingHelperService.getQueryParam('accessToken');
		if (!accessToken) {
			accessToken = this.angularRoutingHelperService.getCurrentRouteParam('accessToken');
		}
		if (this.session.isLoggedIn()) {
			this.restService.postBenuReferenceLinkWithAccessToken({ token: accessToken }, undefined)
				.then((res) => {
					deferred.resolve(res);
				});
		} else {
			this.restService.postBenuPublicReferenceLinkWithAccessToken({ token: accessToken }, undefined)
				.then((res) => {
					deferred.resolve(res);
				}).catch((err) => {
					if (err.status === 403) {
						this.vm.tokenIsExpired = true;
					}
				});
		}
		
		return deferred.promise;
	}
	
}